import { ModelResults, useApiEvidenceV1EvidenceSessionRetrieveSuspense } from 'api';
import type { EvidenceSessionPhotoGalleryItem } from 'ui';

import { getPhotoVariant } from '../../../grade';

export const useEvidenceAiSessionDetails = ({
  date,
  parentContentTypeId,
  parentId,
  uploadedById,
}: {
  date: string;
  parentContentTypeId: number;
  parentId: number;
  uploadedById: number | null;
}) => {
  const { data } = useApiEvidenceV1EvidenceSessionRetrieveSuspense({
    date,
    parent_content_type_id: parentContentTypeId,
    parent_id: parentId,
    uploaded_by: uploadedById,
  });

  const photoEvidence: EvidenceSessionPhotoGalleryItem[] = data.evidence_list
    .filter((evidence) => evidence.file_url && evidence.results)
    .map((evidence) => ({
      annotations: evidence.annotations?.map((annotation) => ({
        label: annotation.label as string,
        rgb_colour: annotation.rgb_colour as number[],
        segmentation: annotation.segmentation as number[][],
      })),
      fullResolutionSrc: evidence.file_url as string,
      src: evidence.preview_url || (evidence.file_url as string),
      variant: getPhotoVariant(evidence.results as unknown as ModelResults),
    }));

  const failedPhotoEvidence = photoEvidence.filter((evidence) => evidence.variant === 'warning');

  return {
    aluminiumComposition: data.aluminium_composition,
    aluminiumLooseAIComposition: data.alu_loose_ai_composition,
    evidenceList: data.evidence_list,
    petComposition: data.pet_composition,
    photoEvidence: photoEvidence,
    stats: {
      failed: failedPhotoEvidence.length,
      passed: photoEvidence.length - failedPhotoEvidence.length,
      total: photoEvidence.length,
    },
    targetWeightPercentage: data.target_weight_percentage,
    totalWeight: data.total_weight,
  };
};
